import { useEffect } from "react";

type UseDragCompletionProps = {
    map: mapboxgl.Map | null;
    isDragging: boolean;
    onDragEnd: () => void;
};

/**
 * Handles mouseup events to complete drag operations
 */
export function useDragCompletion({ map, isDragging, onDragEnd }: UseDragCompletionProps) {
    useEffect(() => {
        if (!map || !isDragging) return;

        function handleMouseUp() {
            if (!map) return;

            // Clear cursor
            map.getCanvas().style.cursor = "";

            onDragEnd();
        }

        map.on("mouseup", handleMouseUp);

        return () => {
            if (!map) return;
            map.off("mouseup", handleMouseUp);
        };
    }, [map, isDragging, onDragEnd]);
}
